import angular from 'angular';

export const applicationsModule = angular.module(
  'portainer.kubernetes.react.components.applications',
  []
).name;
